import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 4v16l-6 -5.5","key":"svg-0"}],["path",{"d":"M14 20v-16l6 5.5","key":"svg-1"}]]

const IconTransferVertical = createReactComponent('outline', 'transfer-vertical', 'TransferVertical', __iconNode);

export default IconTransferVertical;